import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stktq { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '流程碼 (KEY0) 不可空白'}) 
    @MaxLength(1,{message: '流程碼 (KEY0) 資料太長'})
    KEY0: string = '1';            // 流程碼 1 [DEF:"1"]

    @IsNotEmpty({message: '交易日期 (TQ001) 不可空白'}) 
    @MaxLength(8,{message: '交易日期 (TQ001) 資料太長'})
    TQ001: string = '';            // 交易日期 8 struct OVERSEAFUTUREORDER

    @IsNotEmpty({message: '帳號 (TQ002) 不可空白'}) 
    @MaxLength(20,{message: '帳號 (TQ002) 資料太長'})
    TQ002: string = '';            // 帳號 20 bstrFullAccount  分公司代碼＋帳號7碼 F0200008728692

    @IsNotEmpty({message: '序號 (TQ003) 不可空白'}) 
    @MaxLength(4,{message: '序號 (TQ003) 資料太長'})
    TQ003: string = '';            // 序號 4 

    @IsNotEmpty({message: '交易所代碼 (TQ004) 不可空白'}) 
    @MaxLength(10,{message: '交易所代碼 (TQ004) 資料太長'})
    TQ004: string = '';            // 交易所代碼 10 bstrExchangeNo

    @IsNotEmpty({message: '商品代號 (TQ005) 不可空白'}) 
    @MaxLength(20,{message: '商品代號 (TQ005) 資料太長'})
    TQ005: string = '';            // 商品代號 20 BSTR	bstrStockNo; 海外期權代號 最長13碼

    @MaxLength(6,{message: '近月商品年月 (TQ006) 資料太長'})
    TQ006: string = '';            // 近月商品年月 6 bstrYearMonth;		//近月商品年月( YYYYMM) 6碼

    @MaxLength(6,{message: '遠月商品年月 (TQ007) 資料太長'})
    TQ007: string = '';            // 遠月商品年月 6 bstrYearMonth2;		//遠月商品年月( YYYYMM) 6碼 {價差下單使用}

    @IsNumber() 
    TQ008: number = 0;            // 委託價 11.3 BSTR	bstrOrder;			//委託價。

    @IsNumber() 
    TQ009: number = 0;            // 委託價分子 11.3 BSTR	bstrOrderNumerator;	//委託價分子。

    @IsNumber() 
    TQ010: number = 0;            // 委託價分母 11.3 BSTR	bstrOrderDenominator;	//委託價分母

    @IsNumber() 
    TQ011: number = 0;            // 觸發價 11.3 BSTR	bstrTrigger;			//觸發價。

    @IsNumber() 
    TQ011A: number = 0;            // 觸發價分子 11.3 BSTR	bstrTriggerNumerator;	//觸發價分子。

    @IsNumber() 
    TQ012: number = 0;            // 買賣 4 SHORT	sBuySell;				{{0:買進 1:賣出}}  {價差商品，需留意是否為特殊商品－近遠月前的「+、-」符號}

    @IsNumber() 
    TQ013: number = 0;            // 倉別 4 sNewClose;			//新平倉，{{0:新倉}}  {目前海期僅新倉可選}

    @IsNumber() 
    TQ014: number = 0;            // 當沖 4 SHORT	sDayTrade;			//當沖 {{0:否 1:是}}；{海期價差單不提供當沖}	//可當沖商品請參考交易所規定。

    @IsNumber() 
    TQ015: number = 0;            // 委託條件 4 [DEF:0] SHORT	sTradeType;			{{0:ROD 1:FOK 2:IOC}} //{限價單LMT可選ROD/IOC/FOK，市價單依交易所實際提供為主，其餘單別則固定ROD}

    @IsNumber() 
    TQ016: number = 0;            // 特別交易類型 4 SHORT	sSpecialTradeType;		{{0:LMT限價單 1:MKT市價單  2:STL停損限價  3.STP停損市價}}

    @IsNumber() 
    TQ017: number = 1;            // 委託口數 8 LONG	nQty;				//交易口數。

    @IsNotEmpty({message: '登入代號 (TQ018) 不可空白'}) 
    @MaxLength(10,{message: '登入代號 (TQ018) 資料太長'})
    TQ018: string = '';            // 登入代號 10 

    @MaxLength(255,{message: '備註 (TQ019) 資料太長'})
    TQ019: string = '';            // 備註 255 

    @MaxLength(1,{message: '暫存 (TQ020) 資料太長'})
    TQ020: string = 'N';            // 暫存 1 [DEF:"N"] bAsyncOrder 非同步委託 是否為非同步委託。

    @MaxLength(255,{message: '失敗原因 (TQ021) 資料太長'})
    TQ021: string = '';            // 失敗原因 255 

    @MaxLength(1,{message: '價差委託 (TQ022) 資料太長'})
    TQ022: string = 'N';            // 價差委託 1 [DEF:"N"]

    @MaxLength(1,{message: '更新api (TQ023) 資料太長'})
    TQ023: string = 'N';            // 更新api 1 [DEF:"N"]

    @MaxLength(10,{message: '委託書號 (TQ024) 資料太長'})
    TQ024: string = '';            // 委託書號 10 BSTR	bstrBookNo;				//委託書號{改價使用}

    @MaxLength(13,{message: '委託序號 (TQ025) 資料太長'})
    TQ025: string = '';            // 委託序號 13 BSTR	bstrSeqNo;				//委託序號{改價使用}

    @IsNumber() 
    TQ026: number = 0;            // 成交口數 8 //交易口數。

    @MaxLength(8,{message: '異動時間 (TQ027) 資料太長'})
    TQ027: string = '';            // 異動時間 8 hh:mm:ss

    @IsNotEmpty({message: '狀態 (TQ028) 不可空白'}) 
    @MaxLength(1,{message: '狀態 (TQ028) 資料太長'})
    TQ028: string = '1';            // 狀態 1 [DEF:"1"] {{1.已暫存 2.委託失敗 3:已刪除 5.委託成功   8:部分成交  9:全部成交}}

    @MaxLength(60,{message: '商品名稱 (TQ029) 資料太長'})
    TQ029: string = '';            // 商品名稱 60 

    @MaxLength(1,{message: '商品分類 (TQ030) 資料太長'})
    TQ030: string = '0';            // 商品分類 1 [DEF:"0"] MA019 JCKMD STKMA.MA019 {{0:上市 1:上櫃 2:期貨 3:選擇權 4:興櫃 5:盤中零股-上市 6:盤中零股-上櫃  O:海期 Z:指數}}

    @IsNumber() 
    TQ031: number = 0;            // 平均成交價 11.3 


}
